module.exports = __webpack_public_path__ + "img/mission.435a17ec.png";